import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/Radio.css';

const Radio = () => {
  return (
    <>
      <Helmet>
        <title>Radio - Business News & Market Updates | Redbox Global</title>
        <meta name="description" content="Listen to Redbox Global Radio for live business news, market updates, expert commentary, and in-depth analysis. Available 24/7 on multiple platforms." />
        <meta name="keywords" content="business radio, financial radio, live market updates, business news radio, financial commentary, radio streaming, business talk radio, market radio shows" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/radio" />
        <meta property="og:title" content="Radio - Business News & Market Updates | Redbox Global" />
        <meta property="og:description" content="Listen to live business news, market updates, and expert commentary 24/7 on Redbox Global Radio." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1487180144351-b8472da7d491?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/radio" />
        <meta name="twitter:title" content="Radio - Business News & Market Updates | Redbox Global" />
        <meta name="twitter:description" content="Listen to live business news, market updates, and expert commentary 24/7 on Redbox Global Radio." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1487180144351-b8472da7d491?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/radio" />
      </Helmet>
      
      <div className="page-container">
        <div className="page-header">
          <h1>Radio</h1>
          <p className="page-subtitle">24/7 business news, market updates, and expert analysis - on air and online</p>
        </div>
        
        <div className="page-content">
          <a href="/article/morning-market-briefing" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="featured-article">
              <div className="featured-image">
                <img src="https://images.unsplash.com/photo-1487180144351-b8472da7d491?w=1200&h=600&fit=crop" alt="Radio studio" />
              </div>
              <div className="featured-content">
                {/* <span className="article-category">🔴 Live Now</span> */}
                <h2>The Morning Market Briefing</h2>
                <p>Start your day with comprehensive market analysis, breaking business news, and insights from top economists and traders. Broadcasting live weekdays from 6-9 AM ET with hosts Michael Chen and Sarah Williams.</p>
                <span className="article-meta">Live • Weekdays 6-9 AM ET</span>
              </div>
            </div>
          </a>

          <div className="content-grid">
            <a href="/article/midday-markets-show" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=600&h=400&fit=crop" alt="Trading floor" />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Markets</span> */}
                  <h2>Midday Markets</h2>
                  <p>Real-time trading insights and market analysis during peak trading hours.</p>
                  <span className="article-meta">Weekdays • 12-2 PM ET</span>
                </div>
              </article>
            </a>

            <a href="/article/tech-talk-radio" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&h=400&fit=crop" alt="Tech discussion" />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Technology</span> */}
                  <h2>Tech Talk: The Innovation Hour</h2>
                  <p>Exploring technology trends, startup stories, and digital transformation.</p>
                  <span className="article-meta">Tuesdays • 7 PM ET</span>
                </div>
              </article>
            </a>

            <a href="/article/weekend-roundup-radio" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=600&h=400&fit=crop" alt="Weekend discussion" />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Weekly Wrap</span> */}
                  <h2>The Weekend Business Roundup</h2>
                  <p>A comprehensive review of the week's biggest business stories and market moves.</p>
                  <span className="article-meta">Saturdays • 10 AM ET</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Radio;
